// ref: https://github.com/Evaneos/ets-agency-manager-app/blob/main/src/mui-design-system/ThemeProvider.tsx
import './fonts/fonts.css';

import { ThemeOptions } from '@mui/material';

import { getMuiAlert } from './components/alert';
import { getMuiButton } from './components/button';
import { getMuiChip } from './components/chip';
import { getMuiOutlinedInput } from './components/outlinedInput';
import { getMuiSvgIcon } from './components/svgIcon';
import { getMuiTooltip } from './components/tooltip';
import { getTypography } from './components/typography';

import { MuiTypography, getMuiLink, palette } from './';

// rootHtmlFontSize is the root font size of the html element, we need to know this as some apps customize it :(
export const getEvaneosThemeOptions = (
    rootHtmlFontSize = 16
): ThemeOptions => ({
    typography: getTypography(rootHtmlFontSize),
    components: {
        MuiTypography,
        MuiLink: getMuiLink(rootHtmlFontSize),
        MuiButton: getMuiButton(),
        MuiTooltip: getMuiTooltip(rootHtmlFontSize),
        MuiAlert: getMuiAlert(rootHtmlFontSize),
        MuiChip: getMuiChip(rootHtmlFontSize),
        MuiOutlinedInput: getMuiOutlinedInput(),
        MuiSvgIcon: getMuiSvgIcon(),
    },
    palette,
});
